import { env } from '../env';
import loadZendeskWidget from './load-zendesk-widget';

interface ILoadChatArgs {
  userName: string;
  userEmail: string;
  contactFormView: boolean;
}

const startZendeskHelpCenter = async ({ userName, userEmail, contactFormView }: ILoadChatArgs) => {
  const widget = await loadZendeskWidget({
    hideWidgetOnLoad: true,
    apiKey: env.API_ZENDESK_WIDGET,
  });

  if (widget) {
    window.zE?.(() => {
      window.zE?.identify({
        name: userName || '',
        email: userEmail || '',
      });
    });

    widget('webWidget', 'updateSettings', {
      webWidget: {
        contactForm: {
          suppress: false,
        },
        helpCenter: {
          suppress: contactFormView,
        },
      },
    });

    widget('webWidget', 'open');
  }
};

export default startZendeskHelpCenter;
